import { memo } from "react";

import { ExternalLink } from "@/components/ui/button/external-link";

const NOTION_URL = "https://chillnn.notion.site/1bafffe15c57807e9c0fc17ba027be5a";

export const SettingHelpText = memo(() => {
	return (
		<div className="flex gap-x-2">
			<p className="text-sm">
				設定方法に関する詳細な説明は
				<ExternalLink href={NOTION_URL} text="こちら" className="text-sm" />
				をご覧ください。
			</p>
		</div>
	);
});
